import React, { useContext } from 'react';
import { CiCirclePlus } from 'react-icons/ci';

import * as S from './styles';

interface AddBtnProps {
  textBtn: string;
  functionToExecOnclick: any;
}

export default function AddBtn({
  textBtn,
  functionToExecOnclick,
}: AddBtnProps) {
  return (
    <S.container onClick={functionToExecOnclick}>
      <CiCirclePlus />
      <p>{textBtn}</p>
    </S.container>
  );
}
